<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="{{'Users'|translate}}">
      <app-list-users></app-list-users>
  </mat-tab>
  <mat-tab label="{{'Roles'|translate}}" *appHasAPermission="let i;group:groupId; permission:'can_manage_group_roles'">
      <app-manage-group-roles-permissions></app-manage-group-roles-permissions>
  </mat-tab>
</mat-tab-group>